module.exports = __webpack_public_path__ + "img/scenes_2.72981c84.png";